<script setup lang="ts">
import { computed } from "vue";
import { useWorkspaceStore } from "@/stores/workspace";
import { useRoute, RouterView } from "vue-router";
import AppShell from "@/components/AppShell.vue";
import ConfirmDialog from "@/components/ui/ConfirmDialog.vue";
import FeedbackDialog from "@/features/feedback/FeedbackDialog.vue";
import { pageLoadFailure, retryPageLoad } from "@/lib/chunkRecovery";

const route = useRoute();
// sign-in pages and the welcome (onboarding, 2026-10-26) stand alone: no console shell, nothing of it polling
const workspace = useWorkspaceStore();
const isPublic = computed(() => route.meta.public === true || route.meta.bare === true
  || (route.meta.bareWhenHeld === true && workspace.me?.onboarding?.gated === true));   // feedback before joining (2026-10-27)
</script>

<template>
  <div v-if="pageLoadFailure" class="page-load-failure" role="alert">
    <span>This page couldn't load, even after refreshing. Check your connection, then retry.</span>
    <button type="button" class="btn btn--sm" @click="retryPageLoad()">Retry</button>
  </div>
  <RouterView v-if="isPublic" />
  <AppShell v-else>
    <RouterView />
  </AppShell>
  <ConfirmDialog />
  <FeedbackDialog />   <!-- feedback about Majlis, from any page, the welcome too (2026-10-27) -->
</template>

<style scoped>
.page-load-failure {
  position: fixed; z-index: 100; top: var(--space-3); left: 50%; transform: translateX(-50%);
  display: flex; align-items: center; gap: var(--space-3); max-width: calc(100vw - 32px);
  padding: var(--space-2) var(--space-3); border-radius: var(--radius-s);
  background: var(--bg-elev); color: var(--ink); border: 1px solid var(--danger);
  box-shadow: 0 6px 24px rgb(0 0 0 / 0.18); font-size: 0.875rem;
}
</style>
